import { Modal } from 'components/ui/Modal/Modal';
import { useModalContext } from 'hooks';
import { CloseModalButton } from '../CloseModalButton/CloseModalButton';
import { Footer } from '../Footer/Footer';
import { Icon } from './components/Icon';

import './MaintenancePage.scss';

function MaintenancePage() {
  const { closeModal, isModalOpen } = useModalContext();

  return (
    <Modal isOpen={isModalOpen} onClose={closeModal}>
      <CloseModalButton onClick={closeModal} />
      <div className="MaintenancePage">
        <div className="content">
          <Icon />
          <h1>Maintenance mode</h1>
          <p>
            Sorry, our site is currently under maintenance.
            <br />
            We will be back in approximately 30 minutes.
          </p>
          <div>
            <a href="https://www.flywire.com" target="_blank" rel="noreferrer">
              Flywire.com
            </a>
            <a href="https://help.flywire.com" target="_blank" rel="noreferrer">
              FAQ
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </Modal>
  );
}

export { MaintenancePage };
